module.exports = __webpack_public_path__ + "static/media/meta-mask-logo.11446df3.png";